enum CoachingStatus {
  NONE = "none",
  FINISHED = "finished",
  ONCE = "once",
  MONTHLY = "monthly",
  BIWEEKLY = "biweekly",
  WEEKLY = "weekly",
  PROFESSIONAL = "professional",
  EXECUTIVE = "executive",
  CANCELED = "canceled"
}

export const CoachingStatusValues: CoachingStatus[] = [
  CoachingStatus.NONE,
  CoachingStatus.FINISHED,
  CoachingStatus.ONCE,
  CoachingStatus.MONTHLY,
  CoachingStatus.BIWEEKLY,
  CoachingStatus.WEEKLY,
  CoachingStatus.PROFESSIONAL,
  CoachingStatus.EXECUTIVE,
  CoachingStatus.CANCELED
]

export const ActiveSubscriptionCoachingStatusValues: CoachingStatus[] = [
  CoachingStatus.MONTHLY,
  CoachingStatus.BIWEEKLY,
  CoachingStatus.WEEKLY,
  CoachingStatus.PROFESSIONAL,
  CoachingStatus.EXECUTIVE
]

export default CoachingStatus
